const AVATAR_PALETTE = [
  'oklch(0.72 0.13 235)',
  'oklch(0.78 0.13 78)',
  'oklch(0.7 0.14 150)',
  'oklch(0.72 0.15 320)',
  'oklch(0.75 0.13 40)',
  'oklch(0.68 0.13 280)',
];

/** Deterministische Avatarfarbe aus dem Namen — gleicher Name, gleiche Farbe. */
export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length]!;
}
